import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import config from "../config/config";

const EditProgram = ({ programId }) => {

    const { id } = useParams();

    const [formData, setFormData] = useState({
        image: null,
        existingImage: "", // to show existing image
        program: "",
        bannnerHeading: "",
        bannnerSubHeading: "",
        title: "",
        courseList: [],
    });

    useEffect(() => {
        // Fetch existing program data
        const fetchProgram = async () => {
            try {
                const res = await axios.get(`${config.API_BASE_URL}/api/admin/get_programbyId/${id}`);

                console.log("res", res);
                const programData = res.data.getAllProgramById;

                setFormData({
                    image: null, // new image if uploaded
                    existingImage: programData.image, // assuming API returns image URL
                    program: programData.program,
                    bannnerHeading: programData.bannnerHeading,
                    bannnerSubHeading: programData.bannnerSubHeading,
                    title: programData.title,
                    courseList: programData.courseList || [],
                });
            } catch (err) {
                console.error(err);
                alert("Error fetching program data.");
            }
        };

        fetchProgram()
    }, [id]);

    const handleChange = (e, index, field) => {
        if (index !== undefined) {
            const updatedCourses = [...formData.courseList];
            updatedCourses[index][field] = e.target.value;
            setFormData({ ...formData, courseList: updatedCourses });
        } else {
            const { name, value } = e.target;
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleImageChange = (e) => {
        setFormData({ ...formData, image: e.target.files[0] });
    };

    const addCourse = () => {
        setFormData({
            ...formData,
            courseList: [
                ...formData.courseList,
                { course: "", fees: "", eligibility: "", applicationDate: "" },
            ],
        });
    };

    const removeCourse = (index) => {
        const updatedCourses = [...formData.courseList];
        updatedCourses.splice(index, 1);
        setFormData({ ...formData, courseList: updatedCourses });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = new FormData();
        if (formData.image) {
            form.append("image", formData.image);
        }
        form.append("program", formData.program);
        form.append("bannnerHeading", formData.bannnerHeading);
        form.append("bannnerSubHeading", formData.bannnerSubHeading);
        form.append("title", formData.title);
        form.append("courseList", JSON.stringify(formData.courseList));

        try {
            const res = await axios.put(
                `${config.API_BASE_URL}/api/admin/update_program/${id}`,
                form
            );
            alert("Program updated successfully!");
        } catch (err) {
            console.error(err);
            alert("Error updating program.");
        }
    };

    return (
        <div className="container mt-5 pt-5">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10">
                    <h2>Edit Program</h2>
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                        <div className="mb-3">
                            <label className="form-label">Program Image</label>
                            {formData.existingImage && (
                                <div className="mb-2">
                                    <img src={`${config.API_BASE_URL}/uploads/${formData.existingImage}`} alt="Program" style={{ width: "200px" }} />
                                </div>
                            )}
                            <input type="file" className="form-control" onChange={handleImageChange} />
                            <small className="text-muted">Leave empty if you don't want to change the image</small>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Program</label>
                            <input type="text" className="form-control" name="program" value={formData.program} onChange={handleChange} required />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Banner Heading</label>
                            <input type="text" className="form-control" name="bannnerHeading" value={formData.bannnerHeading} onChange={handleChange} required />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Banner Sub Heading</label>
                            <input type="text" className="form-control" name="bannnerSubHeading" value={formData.bannnerSubHeading} onChange={handleChange} required />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Title</label>
                            <input type="text" className="form-control" name="title" value={formData.title} onChange={handleChange} required />
                        </div>

                        <hr />
                        <h5>Course List</h5>
                        {formData.courseList.map((course, index) => (
                            <div className="border p-3 mb-3" key={index}>
                                <div className="row">
                                    <div className="col-md-3">
                                        <label className="form-label">Course</label>
                                        <input type="text" className="form-control" value={course.course} onChange={(e) => handleChange(e, index, "course")} required />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label">Fees</label>
                                        <input type="text" className="form-control" value={course.fees} onChange={(e) => handleChange(e, index, "fees")} required />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label">Eligibility</label>
                                        <input type="text" className="form-control" value={course.eligibility} onChange={(e) => handleChange(e, index, "eligibility")} required />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label">Application Date</label>
                                        <input type="text" className="form-control" value={course.applicationDate} onChange={(e) => handleChange(e, index, "applicationDate")} required />
                                    </div>
                                </div>
                                <button type="button" className="btn btn-danger btn-sm mt-2" onClick={() => removeCourse(index)} disabled={formData.courseList.length === 1}>
                                    Remove
                                </button>
                            </div>
                        ))}

                        <button type="button" className="btn btn-primary mb-3" onClick={addCourse}>
                            Add Course
                        </button>

                        <br />
                        <button type="submit" className="btn btn-success">Update</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditProgram;
